module.exports = __webpack_public_path__ + "static/pB6-869b65fd3af5954f7fda0104da3804b1.png";